export const HANDLING_UNIT = 'HandlingUnit';
export const HandlingUnitStatusValues = [
    'open',
    'closed',
    'consumed',
    'shipped',
    'blocked',
];
export const HANDLING_UNIT_STATUS_LABELS = {
    open: 'Aberto',
    closed: 'Fechado',
    consumed: 'Consumido',
    shipped: 'Expedido',
    blocked: 'Bloqueado',
};
export const HandlingUnitKindValues = [
    'labeled',
    'implicit',
];
export const HANDLING_UNIT_KIND_LABELS = {
    labeled: 'Etiquetado',
    implicit: 'Implícito',
};
/**
 * Statuses that count toward Σ volume == balance (0112 + 0113).
 * `blocked` is present stock (unavailable), so it counts in Σ.
 * Containers (`quantity = 0`) are excluded by the SUM itself.
 */
export const HANDLING_UNIT_ACTIVE_STATUSES = [
    'open',
    'closed',
    'blocked',
];
//# sourceMappingURL=handling-unit.js.map